import './assets/main.css'
import SkLocale from './locales/sk.json'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import PrimeVue from 'primevue/config';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import Dropdown from 'primevue/dropdown';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import MultiSelect from 'primevue/multiselect';
import ProgressBar from 'primevue/progressbar';
import Slider from 'primevue/slider';
import StyleClass from 'primevue/styleclass';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import Tooltip from 'primevue/tooltip';
import ConfirmationService from 'primevue/confirmationservice';

import '@/assets/styles.scss';

const app = createApp(App)
app.config.globalProperties.window = window;
app.provide('aedIconUrls', {
    ready: window.location.origin + '/' + 'layout/images/aed_map_icon_ready.svg',
    notReady: window.location.origin + '/' + 'layout/images/aed_map_icon_notready.svg'
});

app.use(router);
app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC55-kcej_cw07j71XPPEihA33SApNnd6Q'
    }
});
app.use(PrimeVue, 
    { 
        ripple: true,
        locale: SkLocale.sk
    }
);
app.use(ConfirmationService);

app.component('AutoComplete', AutoComplete);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Column', Column);
app.component('DataTable', DataTable);
app.component('Dropdown', Dropdown);
app.component('InputNumber', InputNumber);
app.component('InputText', InputText);
app.component('MultiSelect', MultiSelect);
app.component('ProgressBar', ProgressBar);
app.component('Slider', Slider);
app.component('TriStateCheckbox', TriStateCheckbox);
app.directive('tooltip', Tooltip);
app.directive('styleclass', StyleClass);


app.mount('#app')
